// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"1e3a43c0c897d874","5763":"576559b65ae44a84","6893":"dcbca39a5407b4eb","6974":"69a4c7b580f367c7","7222":"0aaba6f5364572af","7937":"80588d88395b39d0"}[chunkId] + ".js";
};